module.exports = "<button (click)=\"onAddBtnClick()\" [disabled]=\"disable\" class=\"btn btn-success btn-add-new btn-clear\">\n    {{ text }}\n</button>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/settings-add-btn/settings-add-btn.html
// module id = ./web/modern/components/buttons/settings-add-btn/settings-add-btn.html
// module chunks = 0